import React, { useEffect } from 'react';
import { node, string } from 'prop-types';
import ThemeProvider from '../theme/ThemeProvider';
function PropulsionApp(props) {
  const {
    children,
    id
  } = props;
  useEffect(function () {
    if (id) {
      const jssStyles = document.querySelector(`#jss-server-side-${id}`);
      if (jssStyles) {
        jssStyles.parentElement.removeChild(jssStyles);
      }
    }
  }, [id]);
  return /*#__PURE__*/React.createElement(ThemeProvider, null, children);
}
PropulsionApp.propTypes = {
  /**
   * A unique identifier, required if the component was initially rendered by the server.
   *
   * It should match the one used in the server side.
   */
  id: string,
  /** The root component that is using Propulsion. */
  children: node
};
export default PropulsionApp;